/**
 * The base path for operation API methods.
 * @constant
 */
export const OPERATION_BASE_PATH = '/api/mobility/operation';

/**
 * The base path for financial products API methods.
 * @constant
 */
export const FINANCIAL_PRODUCTS_BASE_PATH = '/api/mobility/financial-products';

/**
 * The base path for personal data API methods.
 * @constant
 */
export const PERSONAL_DATA_BASE_PATH = '/api/mobility/common-data/personal-data';

/**
 * The base path for commons data API methods.
 * @constant
 */
export const ADDRESS_DATA_BASE_PATH = '/api/mobility/common-data/address-data';

/**
 * The base path for vendor data API methods.
 * @constant
 */
export const VENDOR_DATA_BASE_PATH = '/api/mobility/vendor-data';

export const HEADER_APIKEY_NAME = 'apiKey';

export const HEADER_USERAGENT_NAME = 'User-Agent';
